import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { ServiceBase } from "./service-base";
import { IGenerateForignStudentPinModel } from "../model/IGenerateForignStudentPinModel";
import { IApplicant } from "../model/IApplicant";
import { CookieService } from "ngx-cookie-service";
import { IApplicantExamination } from "../model/IApplicantExamination";
import { IGuardian } from "../model/IGuardian";
import { CookiesLocalService } from "./cookies-local.service";

@Injectable({
  providedIn: "root",
})
export class ApplicantService extends ServiceBase {
  downloadSrcShuttle() {
    const url =
      this.baseUrl + `/api/ReportDownload/DownloadAdmissionSrcReports`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getApplicantCampusChoice(applicationId: number) {
    const url =
      this.baseUrl +
      `/api/Admission/GetApplicantCampusChoice?applicationId=${applicationId}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getAdmittedApplicant(studentNumber: string) {
    const url =
      this.baseUrl +
      `/api/Admission/GetAdmittedApplicant?studentNumber=${studentNumber}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  downloaddmissionLetter(studentNumber: string) {
    const url =
      this.baseUrl +
      `/api/ReportDownload/DownloadAdmissionLetter?studentNumber=${studentNumber}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  downloadAdmissionItemsNeeded() {
    const url =
      this.baseUrl + `/api/ReportDownload/DownloadAdmissionItemsNeededReports`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  downloadAdmissionFeeSchdule() {
    const url =
      this.baseUrl + `/api/ReportDownload/DownloadAdmissionFeesReports`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  constructor(
    http: HttpClient,
    cookieService: CookieService,
    cookieLocal: CookiesLocalService
  ) {
    super(http, cookieService, cookieLocal);
  }

  removeApplicantExamination(applicantExaminationId) {
    const url =
      this.baseUrl +
      `/api/Admission/RemoveApplicantExamination?id=${applicantExaminationId}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  removeApplicantDocument(id) {
    const url =
      this.baseUrl +
      `/api/Admission/RemoveApplicantDocument?id=${id}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getApplicantAdmissionReport(applicationId: number): any {
    const url =
      this.baseUrl +
      `/api/ReportDownload/GetApplicantAdmissionReport?applicantId=${applicationId}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  saveGuardianData(model: IGuardian) {
    const url = this.baseUrl + "/api/Admission/SaveGuardianData";
    return this.http.post<any>(url, model, this.getHttpHeaderOptionWithToken());
  }

  saveApplicantExamination(model: any) {
    // console.log(model);
    const url = this.baseUrl + "/api/Admission/SaveApplicantExamination";
    return this.http.post<any>(url, model, this.getHttpHeaderOptionWithToken());
  }

  getApplicantExaminations(applicantId: number) {
    const url =
      this.baseUrl +
      `/api/Admission/GetApplicantExaminations?applicantId=${applicantId}`;
    return this.http
      .get<IApplicantExamination[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getApplicantExaminationDetails(applicantId) {
    const url =
      this.baseUrl +
      `/api/Admission/GetApplicantExaminationDetails?applicantId=${applicantId}`;
    return this.http
      .get<any[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getApplicantDocuments(applicantId) {
    const url =
      this.baseUrl +
      `/api/Admission/GetApplicantDocuments?applicantId=${applicantId}`;
    return this.http
      .get<any[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getApplicantExaminationsV2(applicantId) {
    const url =
      this.baseUrl +
      `/api/Admission/GetApplicantExaminations?applicantId=${applicantId}`;
    return this.http
      .get<IApplicantExamination[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  UploadUserPicture(model) {
    const url = this.baseUrl + "/api/FileDirectory/UploadFile";
    return this.http.post<any>(
      url,
      model,
      this.getHttpHeaderOptionWithTokenForMimeType()
    );
  }
  UploadDocument(model) {
    const url = this.baseUrl + "/api/Admission/AddOrEditApplicateDocument";
    return this.http.post<any>(
      url,
      model,
      this.getHttpHeaderOptionWithTokenForMimeType()
    );
  }

  savePersonalData(model: IApplicant) {
    const url = this.baseUrl + "/api/Admission/SavePersonalData";
    return this.http.post<any>(url, model, this.getHttpHeaderOptionWithToken());
  }

  generateForignStudentPin(model: IGenerateForignStudentPinModel) {
    const url = this.baseUrl + "/api/Admission/GenerateForignStudentPin";
    return this.http.post<any>(
      url,
      {
        FullName: model.FullName,
        ApplicationTypeId: model.ApplicationTypeId,
        Email: model.Email,
        PhoneNumber: model.PhoneNumber,
      },
      this.getHttpHeaderOptionWithNoAuthWithJson()
    );
  }
  saveApplicaitonProgrammeOfChoice(model) {
    const url = this.baseUrl + "/api/Admission/SaveApplicantProgrammeOfChoice";
    return this.http.post<any>(url, model, this.getHttpHeaderOptionWithToken());
  }

  getApplicant(studentNumber: string) {
    const url =
      this.baseUrl +
      `/api/Admission/GetApplicationBasicData?studentNumber=${studentNumber}`;
    return this.http
      .get<IApplicant>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getApplicationGuardianData(guardianId: number) {
    const url =
      this.baseUrl +
      `/api/Admission/GetApplicationGuardianData?guardianId=${guardianId}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  geApplicantProgrammeOfChoice(applicationId: number) {
    const url =
      this.baseUrl +
      `api/Admission/GeApplicantProgrammeOfChoice?applicationId=${applicationId}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getApplicantHigherEducationsByApplicantId(applicantId: number) {
    const url =
      this.baseUrl +
      `api/PostgraduateAdmission/GetApplicantHigherEducationsByApplicantId?applicantId=${applicantId}`;
    return this.http
      .get<any[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getApplicantCertificationsByApplicantId(applicantId: number) {
    const url =
      this.baseUrl +
      `api/PostgraduateAdmission/GetApplicantCertificationsByApplicantId?applicantId=${applicantId}`;
    return this.http
      .get<any[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getApplicantResearchExperiencesByApplicantId(applicantId: number) {
    const url =
      this.baseUrl +
      `api/PostgraduateAdmission/GetApplicantResearchExperiencesByApplicantId?applicantId=${applicantId}`;
    return this.http
      .get<any[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getApplicantSeniorHighEducationsByApplicantId(applicantId: number) {
    const url =
      this.baseUrl +
      `api/PostgraduateAdmission/GetApplicantSeniorHighEducationsByApplicantId?applicantId=${applicantId}`;
    return this.http
      .get<any[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getApplicantWorkExperiencesByApplicantId(applicantId: number) {
    const url =
      this.baseUrl +
      `api/PostgraduateAdmission/GetApplicantWorkExperiencesByApplicantId?applicantId=${applicantId}`;
    return this.http
      .get<any[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getPostgraduateApplicantProgrammeOfChoicesByApplicant(applicantId: number) {
    const url =
      this.baseUrl +
      `api/PostgraduateAdmission/GetPostgraduateApplicantProgrammeOfChoicesByApplicant?applicationId=${applicantId}`;
    return this.http
      .get<any[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  saveApplicantHigherEducation(model) {
    const url =
      this.baseUrl + "/api/PostgraduateAdmission/SaveApplicantHigherEducation";
    return this.http.post<any>(url, model, this.getHttpHeaderOptionWithToken());
  }

  saveApplicantCertification(model) {
    const url =
      this.baseUrl + "/api/PostgraduateAdmission/SaveApplicantCertification";
    return this.http.post<any>(url, model, this.getHttpHeaderOptionWithToken());
  }
  saveApplicantResearchExperience(model) {
    const url =
      this.baseUrl +
      "/api/PostgraduateAdmission/SaveApplicantResearchExperience";
    return this.http.post<any>(url, model, this.getHttpHeaderOptionWithToken());
  }
  saveApplicantSeniorHighEducation(model) {
    const url =
      this.baseUrl +
      "/api/PostgraduateAdmission/SaveApplicantSeniorHighEducation";
    return this.http.post<any>(url, model, this.getHttpHeaderOptionWithToken());
  }
  saveApplicantWorkExperience(model) {
    const url =
      this.baseUrl + "/api/PostgraduateAdmission/SaveApplicantWorkExperience";
    return this.http.post<any>(url, model, this.getHttpHeaderOptionWithToken());
  }
  savePostgraduateApplicantProgrammeOfChoice(model) {
    const url =
      this.baseUrl +
      "/api/PostgraduateAdmission/SavePostgraduateApplicantProgrammeOfChoice";
    return this.http.post<any>(url, model, this.getHttpHeaderOptionWithToken());
  }

  removeApplicantHigherEducation(id) {
    const url =
      this.baseUrl +
      `/api/PostgraduateAdmission/RemoveApplicantHigherEducation?id=${id}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  removeApplicantCertification(id) {
    const url =
      this.baseUrl +
      `/api/PostgraduateAdmission/RemoveApplicantCertification?id=${id}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  removeApplicantResearchExperience(id) {
    const url =
      this.baseUrl +
      `/api/PostgraduateAdmission/RemoveApplicantResearchExperience?id=${id}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  removeApplicantSeniorHighEducation(id) {
    const url =
      this.baseUrl +
      `/api/PostgraduateAdmission/RemoveApplicantSeniorHighEducation?id=${id}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  removeApplicantWorkExperience(id) {
    const url =
      this.baseUrl +
      `/api/PostgraduateAdmission/RemoveApplicantWorkExperience?id=${id}`;
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
}
